import { DropdownValue, DropdownOption } from 'components/Dropdown/types';

import { CashInBankAccounts } from 'pages/AuthorizePaymentPage/interCompany/types';

export const createCashAccountsDropdown = (
  cashAccounts: CashInBankAccounts[] | undefined,
  companyId: string
): DropdownValue[] | undefined =>
  cashAccounts
    ?.filter(account => account?.companyId === companyId)
    .map(cashAccount => ({
      label: `${cashAccount.accountNumber} - ${cashAccount.accountName}`,
      value: cashAccount.accountNumber
    }));

export const getCompanyIdFromCashCompany = (
  option: DropdownOption | undefined
): string => option?.value.split('-')[0].trimEnd() || '';
